import { TermoAdesao } from '../interfaces/adesao.dto';

const FOLGA_MS = 5 * 60 * 1000;

/**
 * Só libera assinatura posterior a um envio do plano (desta tela ou gravado no back), ou PDF
 * importado do plano: a consulta de assinatura é por CPF e, sozinha, liberaria termo de outro plano.
 */
export function termoLiberadoPara(
  termo: TermoAdesao | null, planoId: number | undefined, enviadoLocal: { planoId: number; em: Date } | null,
): boolean {
  if (!termo || !planoId) return false;
  const envios = (termo.envios ?? []).filter(e => e.planoId === planoId);
  if (envios.some(e => e.canal === 'importado')) return true;
  if (!termo.liberado) return false;

  const assinadoEm = termo.assinadoEm ? new Date(termo.assinadoEm).getTime() : 0;
  if (enviadoLocal?.planoId === planoId && assinadoEm >= enviadoLocal.em.getTime() - FOLGA_MS) return true;
  return envios.some(e => e.canal !== 'importado' && assinadoEm >= new Date(e.enviadoEm).getTime() - FOLGA_MS);
}
